// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import AccountCompany from "../../components/companies/AccountCompany";
import CompanyTree from "../../components/companies/CompanyTree";
import {
  buildCompanyInfoJson,
  buildCompanyTreeJson,
  companyDialogMessages
} from "../../components/companies/CompileCompanytoJson";
import { hasPrincipal } from "../../../global/containers/UserAuth";
import { LoadingProgress, SnackbarMessage } from "imagus-components";

type GeneralCompanyStateType = {
  loading: boolean,
  messageId: number,
  snackOpen: boolean
};

class GeneralCompany extends Component<*, GeneralCompanyStateType> {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      messageId: 0,
      snackOpen: false
    };
  }

  loadChildCompany = (): * => {
    this.setState({ loading: !this.state.loading });
  };

  switchModalStatus = (status: boolean): * => {
    this.setState({ snackOpen: status });
  };

  openSnackbar = (messageId: number): * => {
    this.setState({ messageId: messageId, snackOpen: true });
  };

  render(): * {
    const company = this.props.company;
    const facebases = company.facebases.edges;
    const canEdit = hasPrincipal(
      "company_children_write",
      this.props.user.groups
    );

    if (company === null || this.state.loading) {
      return (
        <div className="app-main">
          <LoadingProgress />
        </div>
      );
    } else {
      return (
        <div className="app-panel">
          <SnackbarMessage
            open={this.state.snackOpen}
            handleModalStatus={this.switchModalStatus}
            message={companyDialogMessages[this.state.messageId]}
          />
          <AccountCompany
            company={buildCompanyInfoJson(company)}
            canEdit={canEdit}
            facebases={facebases}
            openSnackbar={this.openSnackbar}
          />
          <CompanyTree
            {...buildCompanyTreeJson(company)}
            loadChildCompany={this.loadChildCompany}
            canEdit={canEdit}
          />
        </div>
      );
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  company: state.v3account.company,
  user: state.v3account.user
});

export default connect(mapStateToProps)(GeneralCompany);
